module.exports = __webpack_public_path__ + "img/c10.2401b03c.png";